<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="records" v-loading="listLoading" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column prop="RecordDate" label="记录日期" width="">
          <template slot-scope="scope">
            {{ formatSimpleDate(scope.row.RecordDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="教师姓名" width="">
        </el-table-column>
        <el-table-column prop="TeacherRole" label="身份" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.TeacherRole === 1 ? '' : 'success'">
              {{ scope.row.TeacherRole === 1 ? '班主任' : '任课教师' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ClassName" label="关联班级" width="">
        </el-table-column>
        <el-table-column label="工作内容" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.ConfigNames && scope.row.ConfigNames.length" class="wr-tag-stack">
              <el-tag v-for="tag in scope.row.ConfigNames" :key="tag" size="mini" type="primary" class="wr-stacked-tag">
                {{ tag }}
              </el-tag>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="详细描述" width="120">
          <template slot-scope="scope">
            <div class="v9-content-ellipsis" :title="scope.row.CustomContent">
              {{ scope.row.CustomContent || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="132" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs v-if="showImage(scope.row.MediaFiles).length" :media="scope.row.MediaFiles" :max="3"
              thumb-width="36px" wrapper-class="wr-media-thumbs" img-class="wr-media-thumb" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="附件" width="130" align="center" header-align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.Attachments && scope.row.Attachments.length">
              <template v-for="disp in [buildAttachmentDisplay(scope.row.Attachments)]">
                <div v-if="disp.mode === 'full'" :key="'full-' + scope.$index" class="wr-attach-tags wr-attach-tags--full">
                  <el-tag
                    v-for="tag in disp.visibleTags"
                    :key="tag.ext"
                    size="mini"
                    type="info"
                    class="wr-attach-tag"
                  >
                    {{ tag.label }}
                  </el-tag>
                </div>
                <div v-else :key="'compact-' + scope.$index" class="wr-attach-tags wr-attach-tags--compact">
                  <div class="wr-attach-row">
                    <el-tag
                      v-for="tag in disp.visibleTags"
                      :key="tag.ext"
                      size="mini"
                      type="info"
                      class="wr-attach-tag"
                    >
                      {{ tag.label }}
                    </el-tag>
                  </div>
                  <span class="wr-attach-more">等{{ disp.moreCount }}个附件</span>
                </div>
              </template>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="SubmitTime" label="提交时间" width="160">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="handleDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="PageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <work-record-detail-dialog :visible.sync="detailVisible" :record="detailRecord" />

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getWorkRecordList, exportWorkRecordList } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps'
import WorkRecordDetailDialog from '../../components/WorkRecord/WorkRecordDetailDialog.vue'
import {
  fileExtFromMedia,
} from "../../utils/mediaUrl";

export default {
  components: { Toolbar, DepartmentPane, WorkRecordDetailDialog },
  data() {
    return {
      BaseApiUrl: BaseApiUrl,
      filters: {
        teacherName: '',
        role: null,
        startDate: '',
        endDate: ''
      },
      searchList: [
        {
          label: '教师姓名',
          key: 'teacherName',
          width: '150px',
          initValue: ''
        },
        {
          label: "身份",
          key: "role",
          type: "select",
          width: '120px',
          clearable: true,
          initValue: null,
          options: [
            { label: "班主任", value: 1 },
            { label: "任课教师", value: 2 },
          ]
        },
        {
          label: "开始时间",
          key: "startDate",
          type: "date",
          width: '170px',
          initValue: ''
        },
        {
          label: "结束时间",
          key: "endDate",
          type: "date",
          width: '170px',
          initValue: ''
        },
      ],
      records: [],
      total: 0,
      page: 1,
      PageSize: 10,
      listLoading: false,
      buttonList: [],
      departmentId: 0,

      detailVisible: false,
      detailRecord: null,
    };
  },
  methods: {
    formatTime(time) {
      return time ? util.formatDate.format(new Date(time), "yyyy-MM-dd HH:mm:ss") : "";
    },
    formatSimpleDate(time) {
      return time ? util.formatDate.format(new Date(time), "yyyy-MM-dd") : "";
    },
    treeNodeClick(data) {
      const id = treeNodeDeptId(data);
      if (!id) return;
      this.departmentId = id;
      this.page = 1;

      // 彻底清空状态与 UI
      if (this.$refs.toolbar) {
        this.filters.teacherName = "";
        this.filters.role = null;
        this.filters.startDate = "";
        this.filters.endDate = "";

        this.$refs.toolbar.searchObj = {
          teacherName: "",
          role: null,
          startDate: "",
          endDate: ""
        };
      } else {
        this.filters.teacherName = "";
        this.filters.role = null;
      }

      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行查询", type: "error" });
        return;
      }
      let para = {
        departmentId: this.departmentId,
        page: this.page,
        PageSize: this.PageSize,
        ...this.filters
      };
      this.listLoading = true;
      console.log("[WorkRecordDebug] WorkRecordList.handleQuery", {
        component: "WorkRecordList",
        routePath: this.$route.path,
        api: "/api/WorkRecordAdmin/GetRecordList",
        para
      });
      getWorkRecordList(para).then(async (res) => {
        if (res.data.success) {
          const rows = res.data.response.data || [];
          await this.prefetchListOssMedia(rows, 'MediaFiles');
          this.records = rows;
          this.total = res.data.response.dataCount || 0;
        }
        this.listLoading = false;
      });
    },
    async exportExcel() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行导出", type: "error" });
        return;
      }
      try {
        let para = {
          departmentId: this.departmentId,
          ...this.filters
        };

        var fileName = "工作记录汇总";
        const departmentPane = this.$children.find(c => c.$options.name === 'DepartmentPane');
        if (this.currentDepartment && this.currentDepartment.label) {
          fileName += "-" + this.currentDepartment.label;
        }

        const response = await exportWorkRecordList(para);
        if (!response.data) {
          this.$message.error("导出数据为空");
          return;
        }

        // 优先使用后端返回的文件名
        let finalFileName = fileName + ".xlsx";
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            let backendFileName = matches[1].replace(/['"]/g, '');
            // 处理 RFC 5987 编码格式 (例如 filename*=utf-8''%e6%b5%8b%e8%af%95.xlsx)
            if (backendFileName.toLowerCase().startsWith("utf-8''")) {
              backendFileName = decodeURIComponent(backendFileName.substring(7));
            } else {
              // 兼容性解码
              try {
                backendFileName = decodeURIComponent(backendFileName);
              } catch (e) {
                console.warn("文件名解码失败", e);
              }
            }
            if (backendFileName) finalFileName = backendFileName;
          }
        }

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', finalFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功");
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error("导出失败");
      }
    },
    handleDetail(row) {
      this.detailRecord = row;
      this.detailVisible = true;
    },
    /** 列表附件类型键（优先 FileType，否则从 URL 推断） */
    attachmentTypeKey(file) {
      const ext = fileExtFromMedia(file && file.FileUrl, file && file.FileType);
      if (!ext) return '文件';
      return ext.replace(/^\./, '').toLowerCase();
    },
    getAttachmentCounts(attachments) {
      const counts = {};
      (attachments || []).forEach(file => {
        const ext = this.attachmentTypeKey(file);
        counts[ext] = (counts[ext] || 0) + 1;
      });
      return counts;
    },
    /**
     * 列表附件列展示：≤3 种类型最多三行横排；超出则两行（前 2 个标签 + 等 N 个附件）
     */
    buildAttachmentDisplay(attachments) {
      const list = attachments || [];
      const counts = this.getAttachmentCounts(list);
      const tags = Object.keys(counts).map((ext) => ({
        ext,
        count: counts[ext],
        label: `${counts[ext]}个${ext}`,
      }));
      if (tags.length <= 3) {
        return { mode: 'full', visibleTags: tags, moreCount: 0 };
      }
      const visibleTags = tags.slice(0, 2);
      const shownFileCount = visibleTags.reduce((sum, t) => sum + t.count, 0);
      return {
        mode: 'compact',
        visibleTags,
        moreCount: Math.max(0, list.length - shownFileCount),
      };
    },
    /** 单张图片完整地址（已是 http(s) 则不再拼接 BaseApiUrl） */
    resolveMediaUrl(path) {
      return this.$resolveImageSrc(path);
    },
    /** 预览大图用的完整 URL 列表 */
    mediaFullUrls(mediaFiles) {
      return this.showImage(mediaFiles).map(p => this.resolveMediaUrl(p));
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search;
      } else {
        this.filters = { teacherName: item.search };
      }
      this[item.Func].apply(this, [item]);
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);

    // 从统计页「查看明细」带入筛选条件。最后更新：2026-07-23
    const q = this.$route.query || {};
    if (q.teacherName || q.startDate || q.endDate) {
      this.filters.teacherName = q.teacherName || '';
      this.filters.startDate = q.startDate || '';
      this.filters.endDate = q.endDate || '';
      this.$nextTick(() => {
        if (this.$refs.toolbar) {
          this.$refs.toolbar.searchObj = Object.assign({}, this.$refs.toolbar.searchObj || {}, {
            teacherName: this.filters.teacherName,
            startDate: this.filters.startDate,
            endDate: this.filters.endDate
          });
        }
      });
    }

    console.log("[WorkRecordDebug] WorkRecordList.mounted", {
      component: "WorkRecordList",
      routePath: this.$route.path,
      expectedApi: "/api/WorkRecordAdmin/GetRecordList"
    });
  }
};
</script>

<style scoped>
/* V9 提升展示密度 */
.wr-tag-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.wr-stacked-tag {
  border-radius: 4px;
  max-width: 100%;
}

/* 列表内容溢出处理 */
.v9-content-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 最多显示2行 */
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

/* 列表「图片」列（对齐班级圈帖子管理媒体列：132px / 36px 缩略图） */
.wr-media-thumbs {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.wr-media-thumb {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

/* 列表「附件」列（WorkRecordAttachment） */
.wr-attach-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  gap: 2px 4px;
}
.wr-attach-tags--full {
  max-height: 66px;
  overflow: hidden;
}
.wr-attach-tags--compact {
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.wr-attach-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 4px;
}
.wr-attach-more {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.3;
  white-space: nowrap;
}
.wr-attach-tag {
  margin: 0;
  flex-shrink: 0;
}
</style>
